import React, { useEffect, useState, useRef } from "react";
import "./stylessh.css";
import { armonizacion } from "../../../json/armonizacion";


const Conac = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Armonizacion Contable</h1>
          </div>
          <div className="containerimg">
                <img width="350"  src={"../../../contenido/transparencia/armonizacion/img/safac.png"}/>  
                                   
                </div>
                <div className="containerimg">
                <img width="350"  src={"../../../contenido/transparencia/armonizacion/img/AC.jpg"}/>  
                                   
                </div>
        </div>
      </div>
    
       <div className="steps-row">
        {armonizacion.map((item, index) => (
          <div key={index} className="col-12 seccion">
                <h1 className="mt-5 titulo-seccion">{item.id_trimestre}</h1>
                <div className="bloque">
                {item.titulos_array.map((title, i) => (      
                    <div>  
                      <h5 className="mt-3 titulo-bloque">{title.titulo_item_nombre}</h5>
                          <div className="cuerpo-bloque">
                            {title.archivos_array.map((archivo, j) => (             
                              <div>
                              {" "}
                              <div>{archivo.texto}</div>
                              <a className={archivo.extencion}
                                target="{_blank}"
                                key={i}
                                href={archivo.file_item_url}
                              >
                                {archivo.file_item_nombre}
                              </a>{" "}
                            </div>

                            ))}
                          </div>
                  
                     
                    
                    </div>
                ))}
                        
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Conac;
